import {customElement, property} from "lit/decorators.js";
import {CSSResult, html, LitElement, unsafeCSS} from "lit";
import {consume} from "@lit/context";

import {Article, Messages} from "../../@types/online-reservation.js";
import { i18nContext } from "./i18nContext.js";

import styles from './step-five.scss';
import './product-section/product-section.js';
import './reservation-badges/reservation-badges.js';
import checkIcon from '@breuni-ui/bdk/dist/design-tokens/images/icons/o-ic-24_check.svg';
import {addPresentationToIcon} from "../icon/icon-accessibility.js";

@customElement('step-five')
export class StepFive extends LitElement {
  @property({ type: Function }) onNext!: () => void;
  @property({ type: Function }) onRetry!: () => void;
  @property({ type: Boolean }) reservationSuccessful = true;

  @consume({context: i18nContext})
  private messages!: Messages;

  @property({type: Object, reflect: false})
  private readonly article: Article = {
    brand: 'Test Brand',
    name: 'Test Article Name',
    color: 'Black',
    price: {
      value: '29.99 €',
      priceReduced: false
    },
    image: {
      src: 'https://cms.brnstc.de/product_images/435x596p/cpro/media/images/product/24/7/100159661215000_0_1722163931092.webp',
      alt: 'Test Article Image'
    }
  };

  @property({type: Object, reflect: false})
  private readonly sizeDescription: string = 'S - 32';

  @property({type: String, reflect: false})
  private readonly storeLocationName: string = 'Stuttgart';

  @property({ type: Boolean })
  private showSizeBadge = true;

  static get styles(): CSSResult {
    return unsafeCSS(styles);
  }

  render() {
    return html`
      <div class="ents-reservation-closed">
        <div class="ents-reservation-closed__product_section">
          <product-section
            .article=${this.article}
          ></product-section>
        </div>
        <reservation-badges
          .sizeDescription=${this.sizeDescription}
          .storeLocationName=${this.storeLocationName}
          .showSizeBadge=${this.showSizeBadge}
        ></reservation-badges>
        ${this.reservationSuccessful ? this.renderSuccess() : this.renderFail()}
      </div>
    `;
  }

  renderSuccess() {
    return html`
      <div class="ents-reservation-closed__header">
        ${addPresentationToIcon(checkIcon())}
        <h2 class="ents-heading-medium ents-reservation-closed__header--text">${this.messages.success}</h2>
      </div>
      <span class="ents-copy">${this.messages.successText}</span>
      <div class="ents-reservation-closed__buttons">
        <button
          class="bdk-button ents-reservation-closed__button--close"
          type="button"
          variant="primary"
          size="medium"
          full-width
          @click=${this.onNext}
        >
          ${this.messages.close}
        </button>
      </div>
    `;
  }

  renderFail() {
    return html`
      <span class="ents-copy-bold error">${this.messages.errorHeadline}</span>
      <p class="ents-copy">${this.messages.error}</p>
      <div class="ents-reservation-closed__buttons">
        <button
          class="bdk-button ents-reservation-closed__button--close"
          type="button"
          variant="outline"
          size="medium"
          full-width
          @click=${this.onNext}
        >
          ${this.messages.close}
        </button>
        <button
          class="bdk-button"
          type="button"
          variant="primary"
          size="medium"
          full-width
          @click=${this.onRetry}
        >
          ${this.messages.tryAgain}
        </button>
      </div>
    `;
  }
}
